export enum LANGUAGE {
    PORTUGUESE = 1,
    ENGLISH = 2,
    SPANISH = 3,
    LIBRAS = 4
}